import { render, staticRenderFns } from "./qr-referral.vue?vue&type=template&id=4c0c98de&lang=pug&"
import script from "./qr-referral.vue?vue&type=script&lang=js&"
export * from "./qr-referral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports